module.exports = "../../app/cells/components/campaigns/interventions/leaderboard_cell.rb";